import * as Blockly from 'blockly/core';
// import { VmtFieldFlyoutText } from '../fields/VmtFlyout/VmtFlyoutEditField';
// import { createMinusField } from '../fields/field_minus';
// import { createPlusField } from '../fields/field_plus';
// import { getExtraBlockState } from '../fields/serialization_helper';
import { Colors } from '../../const';

const REUSABLE_BRICK_COLOR = Colors.REUSABLE_BRICK_COLOR; //'#138D90';


/**
 * The parameter block.
 * @type {Blockly.Block}
 */
Blockly.Blocks['vmt_return'] = {
    /**
     * Initializes the block.
     * @this {Blockly.BlockSvg}
     */
    init: function () {
        this.jsonInit({
            // "type": "my_block",
            "tooltip": "Return from a reuable block",
            "helpUrl": "",
            "message0": "%1%2",
            "args0": [
                {
                    "type": "field_image",
                    "src": "media/images/reply_24dp_FFFFFF.svg",
                    "width": 20,
                    "height": 20,
                    "alt": "ret:",
                    "flipRtl": "FALSE"
                },
                {
                    "type": "input_value",
                    "name": "VALUE",
                }
            ],
            "previousStatement": null,
            "nextStatement": null,
            "colour": REUSABLE_BRICK_COLOR,
            "mutator": "vmt_return_input_value_mutator",
        });
    },

    /**
     * Is this block enclosed (at any level) by a reusable block?
     *  If so, return the top level block, otherwise return null.
     * @this {Blockly.Block}
     * @return {Blockly.Block} The top level block that encloses this block.
     */
    getSurroundReusableBlock: function () {
        console.log('getSurroundReusableBlock');
        const reusableBlockTypes = new Set(['vmt_reusable_brick_init', 'vmt_reusable_brick_init_statement']);
        /** @type {{type: string, parentBlockId: string}} */
        const paramData = JSON.parse(this.data);
        const parentBlockId = paramData.parentBlockId;
        let block = this;
        do {
            if (reusableBlockTypes.has(block.type)/* && block.id === parentBlockId*/) {
                if (block.id === parentBlockId) {
                    return block;
                }
                // return block;
                return null;
            }
            block = block.getSurroundParent();
        } while (block);
        return null;
        // return false;
    },

    /**
     * It checks:
     *  - for the return block location and sets the warning message accordingly.
     *  - for the checkbox value of the parent block and sets the value input or dummy input accordingly.
     * @param {Blockly.Events.Abstract} e Change event.
     * @this {Blockly.BlockSvg}
     */
    onchange: function (e) {
        if (this.isShadow()) {
            return;
        }

        // check for the checkbox value of the parent block and 
        // sets the value input or dummy input accordingly
        if ((e.type === Blockly.Events.BLOCK_CHANGE && e.name === 'IS_RETURN_VALUE') ||
            (e.type === Blockly.Events.BLOCK_CREATE && e.blockId === this.id)) {
            /** @type {{type: string, parentBlockId: string}} */
            const paramData = JSON.parse(this.data);
            const parentBlockId = paramData.parentBlockId;
            if (e.type === Blockly.Events.BLOCK_CREATE || e.blockId === parentBlockId) {
                const workspace = this.workspace;
                const reusableBlock = workspace.getBlockById(parentBlockId);
                const isReturnValue = reusableBlock.getField('IS_RETURN_VALUE').getValue() === 'TRUE';  // true
                this.updateShape_(isReturnValue);
                // if (isReturnValue) {
                //     this.removeInput('VALUE_DUMMY', true);
                //     this.removeInput('VALUE', true);
                //     this.appendValueInput('VALUE') // return value
                //         .appendField(new Blockly.FieldImage("media/images/reply_24dp_FFFFFF.svg", 20, 20));
                // }
                // else {
                //     this.removeInput('VALUE', true);
                //     this.appendDummyInput('VALUE_DUMMY') // no return value
                //         .appendField(new Blockly.FieldImage("media/images/reply_24dp_FFFFFF.svg", 20, 20));
                // }
            }
        }

        // check for the return block location and sets the warning message accordingly
        const warningMsg = 'Warning: This block may only be used inside its own reusable block';
        const ws = this.workspace;
        // Don't change state if:
        //   * It's at the start of a drag.
        //   * It's not a move event.
        if (
            !ws.isDragging ||
            ws.isDragging() ||
            (e.type !== Blockly.Events.BLOCK_MOVE && e.type !== Blockly.Events.BLOCK_CREATE)
        ) {
            return;
        }
        const enabled = !!this.getSurroundReusableBlock();
        this.setWarningText(
            enabled ? null : warningMsg,
        );

        if (!this.isInFlyout) {
            try {
                // There is no need to record the enable/disable change on the undo/redo
                // list since the change will be automatically recreated when replayed.
                Blockly.Events.setRecordUndo(false);
                this.setDisabledReason(
                    !enabled,
                    warningMsg,
                );
            } finally {
                Blockly.Events.setRecordUndo(true);
            }
        }
    }
};

/**
 * Mutator for the input value block.
 * @type {Blockly.Mutator}
 * @typedef {function(this:Blockly.Block, Blockly.Events.Abstract)} Mutator
 */
const inputValueCreateMutator = {

    isReturnValue_: false,

    /**
     * Returns the state of this block as a JSON serializable object.
     * @returns {{itemCount: number}} The state of this block, ie the item count.
     */
    saveExtraState: function () {

        const state = Object.create(null);
        state['isReturnValue'] = this.isReturnValue_;

        // if (!this.hasStatements_) {
        //     state['hasStatements'] = false;
        // }
        return state;
    },

    /**
     * Applies the given state to this block.
     * @param {*} state The state to apply to this block, ie the item count.
     */
    loadExtraState: function (state) {
        this.updateShape_(state['isReturnValue']);
    },

    updateShape_: function (isReturnValue) {
        this.isReturnValue_ = isReturnValue;
        if (isReturnValue) {
            this.removeInput('VALUE_DUMMY', true);
            this.removeInput('VALUE', true);
            this.appendValueInput('VALUE') // return value
                .appendField(new Blockly.FieldImage("media/images/reply_24dp_FFFFFF.svg", 20, 20));
        }
        else {
            this.removeInput('VALUE', true);
            this.appendDummyInput('VALUE_DUMMY') // no return value
                .appendField(new Blockly.FieldImage("media/images/reply_24dp_FFFFFF.svg", 20, 20));
        }
    },
};

/**
 * Updates the shape of the block to have 3 inputs if no mutation is provided.
 * @this {Blockly.Block}
 */
const inputValueCreateMutatorHelper = function () {
    this.isReturnValue_ = false;
    // this.updateShape_(this.isReturnValue_);
};

Blockly.Extensions.registerMutator(
    'vmt_return_input_value_mutator',
    inputValueCreateMutator,
    inputValueCreateMutatorHelper,
);
